import React from "react";
import SVG from 'react-inlinesvg';
import fb from "./assets/facebook.svg"
import tw from "./assets/twitter.svg"
import pin from "./assets/pinterest.svg"
import ins from "./assets/instagram.svg"
import logoSmall from "../Footer/assets/wr.png";

const Footer = () => {
  return (
    <div className="footer-wrapper text-center row pt-3 pb-3">
      <div className="col-md-3 text-center">
        The term ‘Etsy’ is a trademark of Etsy, Inc.
        Etsy does not endorse or sponsor this app.
      </div>
      <div className="col-md-3 offset-md-5">
          <a className="btn btn-contact-us" href="https://www.etsy.com/conversations/new?with_id=81133603">
                  <img src={logoSmall} className="col-md-6 offset-md-3 " alt="logo" />
                  Questions?  Contact Us
          </a>
      </div>
    </div>
  );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/app/Footer/Footer.js